import parse, { domToReact as domToReact$1 } from 'html-react-parser';
export { Element } from 'html-react-parser';

const parseHtml = (html, options)=>parse(html, options)
;
const domToReact = (nodes)=>domToReact$1(nodes)
;

export { domToReact, parseHtml };
//# sourceMappingURL=parse-html.js.map
